module.exports = __webpack_public_path__ + "static/media/vinglabs_health_color_transparent.058e7256.png";